export const UserDetails = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const isSuccess = Math.random() > 0.5
      if (isSuccess) {
        resolve({message: 'Data fetched successfully!'})
      } else {
        reject('Error: Something went wrong.')
      }
    }, 2000)
  })
}
